class ProductCard extends HTMLElement {
    constructor() {
        super()
        const colors = this.dataset.colorVariant?.toLowerCase().split(" ") || [];
        const isColor = this.isColor(colors)
        if (!isColor) {
            const label = this.querySelector("label") || this.querySelector("span") || this;

            label.style.background = `url(${this.dataset.fileUrl})`;
            label.style.backgroundSize = "cover";
            label.style.backgroundPosition = "center";
            if(!this.dataset.fileUrl) {
                const span = this.querySelector('span.color_variant')
                if(span) span.style.background = `radial-gradient(circle, rgba(153,157,158,1) 0%, rgba(255,255,255,1) 100%)`
            }
        } else {
            const span = this.querySelector('span.color_variant')
            if(span) span.style.background = this.findColor(colors)
        }
        const ids = this.dataset.variantsId.split(',')
        const options = this.dataset.variantsOption.split(',')
        const result = {}
        options.forEach((option, i) => result[option] = (result[option] || []).concat(ids[i]))
        this.onkeypress = (e) => {
            if (e.key === "Enter") {
                window.open(`${window.location.origin}/products/${this.dataset.handle}?variant=${result[this.dataset.colorVariant][0]}`, "_self")
            }
        }
        this.onclick = () => {
            window.open(`${window.location.origin}/products/${this.dataset.handle}?variant=${result[this.dataset.colorVariant][0]}`, "_self")
        }
    }

    handleVariantImg(color, id = "", index = 0, show) {
        const img = document.querySelector(`[data-color-selector="product_card_${id}_${index}_${color}"]`)
        if (!img) {
            return;
        }

        if (show) {
            img.classList.remove('hide')
        } else {
            img.classList.add('hide')
        }
    }

    isColor = (strColors = []) => {
       return strColors.some(strColor => {
            const s = new Option().style;
            s.color = strColor;
            return s.color == strColor;
        })
    }

    findColor = (strColors = []) => {
        return strColors.find(strColor => {
             const s = new Option().style;
             s.color = strColor;
             return s.color == strColor;
         })
     }
}
customElements.define('product-card', ProductCard);